function extractYouTubeId(url) {
  try {
    const u = new URL(url);
    if (u.hostname.includes("youtu.be")) {
      return u.pathname.replace("/", "");
    }
    if (u.searchParams.has("v")) {
      return u.searchParams.get("v");
    }
    const parts = u.pathname.split("/");
    return parts.pop();
  } catch (e) {
    return "";
  }
}

function buildEmbedUrl(id) {
  return `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`;
}

function pauseAllVideos(swiper) {
  swiper.slides.forEach((slide) => {
    const item = slide.querySelector(".product-youtube-videos__item");
    if (!item) return;
    
    const video = item.querySelector("video");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    
    const iframe = item.querySelector("iframe");
    if (iframe && iframe.dataset.baseSrc) {
      iframe.src = iframe.dataset.baseSrc + '&mute=1';
    }
  });
}

function playActiveVideo(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  if (!activeSlide) return;
  
  const activeItem = activeSlide.querySelector(".product-youtube-videos__item");
  if (!activeItem) return;
  
  const video = activeItem.querySelector("video");
  if (video) {
    video.play().catch(() => {});
    return;
  }
  
  const iframe = activeItem.querySelector("iframe");
  const url = activeItem.dataset.url;
  if (iframe && url) {
    const id = extractYouTubeId(url);
    const base = buildEmbedUrl(id);
    iframe.dataset.baseSrc = base;
    iframe.src = `${base}&mute=1&autoplay=1`;
  }
}

function setupVideo(slide, swiper) {
  const item = slide.querySelector(".product-youtube-videos__item");
  if (!item) return;
  
  const type = item.dataset.type;
  const url = item.dataset.url;
  
  if (type === "youtube") {
    const iframe = item.querySelector("iframe");
    if (iframe) {
      const id = extractYouTubeId(url);
      const base = buildEmbedUrl(id);
      iframe.dataset.baseSrc = base;
      iframe.src = `${base}&mute=1`;
    }
  } else if (type === "video") {
    const video = item.querySelector("video");
    const btn = item.querySelector(".product-youtube-videos__sound-toggle");
    
    if (video) {
      let videoUrl = url;
      if (url.toLowerCase().includes('dropbox.com')) {
        videoUrl = url
          .replace('www.dropbox.com', 'dl.dropboxusercontent.com')
          .replace('?dl=0', '?raw=1')
          .replace('?dl=1', '?raw=1');
      }
      video.src = videoUrl;
      video.muted = true;
      video.playsInline = true;
      video.loop = true;
      video.preload = "metadata";
    }
    
    if (btn && video) {
      btn.replaceWith(btn.cloneNode(true));
      const newBtn = item.querySelector(".product-youtube-videos__sound-toggle");
      
      newBtn.addEventListener("click", (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
        newBtn.classList.toggle("is-unmuted", !video.muted);
        if (!video.muted && video.paused) {
          video.play().catch(() => {});
        }
      });
    }
  }
  
  item.addEventListener("click", (e) => {
    if (e.target.closest(".product-youtube-videos__sound-toggle")) return;
    
    const isActive = slide.classList.contains("swiper-slide-active");
    if (!isActive) {
      const slideIndex = slide.getAttribute("data-swiper-slide-index");
      if (slideIndex !== null) {
        swiper.slideToLoop(parseInt(slideIndex, 10));
      }
    }
  });
}

function initProductVideos() {
  const sliders = document.querySelectorAll(".product-youtube-videos__slider.swiper");
  if (!sliders.length) return;
  
  sliders.forEach((sliderEl) => {
    if (sliderEl.swiper) {
      sliderEl.swiper.destroy(true, true);
    }
    
    const swiper = new Swiper(sliderEl, {
      loop: true,
      loopAdditionalSlides: 3,
      centeredSlides: true,
      initialSlide: 0,
      slidesPerView: 1.4,
      spaceBetween: 16,
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 20
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 24
        }
      },
      on: {
        init: function() {
          setTimeout(() => {
            this.slides.forEach(slide => setupVideo(slide, this));
            pauseAllVideos(this);
            playActiveVideo(this);
          }, 100);
        },
        slideChange: function() {
          pauseAllVideos(this);
          playActiveVideo(this);
        }
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProductVideos);
} else {
  initProductVideos();
}

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    const sliders = document.querySelectorAll(".product-youtube-videos__slider.swiper");
    sliders.forEach((sliderEl) => {
      if (sliderEl.swiper) {
        sliderEl.swiper.update();
      }
    });
  }, 250);
});